const data = {
  id: 1,
  title: 'Look and write',
  subTitle: 'Nhìn hình và hoàn thành từ với chữ cái cho sẵn',
  question: 's__',
  answers: 'sea',
  imageUrl: 'https://www.surfertoday.com/images/stories/seawater4.jpg',
};

export default data;
